import { ApiService } from "./apiService"

export const TopListService =function(){
    return{
        getAll:async function(){
            const response = await ApiService.get(`/api/items/toplist?fields=location.cover_image.id,
                location.cover_image.width,
                location.cover_image.height,
                location.description,
                location.id,
                location.name,
                location.map_cover_image.id,
                location.map_cover_image.width,
                location.map_cover_image.height,
                location.map.cover,
                location.coordinates,
                location.translations.*`);
            return response.data;
        }
    }
}